import React, {useEffect} from 'react'
import {useIntl} from 'react-intl'
import PropTypes from 'prop-types'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {
    MODEL_3D_CONFIG_FILE_URL,
    MODEL_3D_GRAPHICS_PATH,
    MODEL_3D_ROOT_PATH,
    MODEL_3D_ALT,
    MODEL_3D_RESPONSIVE_BASE_WIDTH,
    MODEL_3D_RESPONSIVE_MIN_HEIGHT,
    MODEL_3D_LICENSE_CODE
} from '@consteed/overrides/constants'

import '@webrotate360/imagerotator/build/css/all.css'

export const WebRotator = ({
    id = 'webrotate360',
    configFileURL = MODEL_3D_CONFIG_FILE_URL,
    graphicsPath = MODEL_3D_GRAPHICS_PATH,
    rootPath = MODEL_3D_ROOT_PATH,
    alt = MODEL_3D_ALT,
    responsiveBaseWidth = MODEL_3D_RESPONSIVE_BASE_WIDTH,
    responsiveMinHeight = MODEL_3D_RESPONSIVE_MIN_HEIGHT
}) => {
    const intl = useIntl()

    useEffect(() => {
        let viewerApi = null
        // image rotator is loaded dynamically here as it uses window object
        import('@webrotate360/imagerotator').then(({default: WR360}) => {
            const viewer = WR360.ImageRotator.Create(id)
            viewer.licenseCode = MODEL_3D_LICENSE_CODE
            viewer.settings.configFileURL = configFileURL
            viewer.settings.graphicsPath = getAssetUrl(graphicsPath)
            viewer.settings.rootPath = getAssetUrl(rootPath)
            viewer.settings.alt = typeof alt === 'object' ? intl.formatMessage(alt) : alt
            viewer.settings.responsiveBaseWidth = responsiveBaseWidth
            viewer.settings.responsiveMinHeight = responsiveMinHeight
            // TODO check why fullscreen mode is not working as expected (does not show image, does not open after closing)

            viewer.settings.apiReadyCallback = (api) => {
                viewerApi = api
                if (viewerApi) {
                    // TODO this is just an example of how to use the API
                    viewerApi.images.onDrag((event) => {
                        console.log(
                            `${event.action}; current image index = ${viewerApi.images.getCurrentImageIndex()}`
                        )
                    })
                }
            }
            viewer.runImageRotator()
        })

        return () => {
            viewerApi && typeof viewerApi.destroy === 'function' && viewerApi.destroy()
            viewerApi = null
        }
    }, [])

    return <div id={id} />
}
WebRotator.propTypes = {
    id: PropTypes.string,
    configFileURL: PropTypes.string,
    graphicsPath: PropTypes.string,
    rootPath: PropTypes.string,
    alt: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    responsiveBaseWidth: PropTypes.number,
    responsiveMinHeight: PropTypes.number
}

export default WebRotator
